import { render } from "./description-form.vue?vue&type=template&id=fbf36fa4"
import script from "./description-form.vue?vue&type=script&setup=true&lang=js"
export * from "./description-form.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/roles/description-form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fbf36fa4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fbf36fa4', __exports__)) {
    api.reload('fbf36fa4', __exports__)
  }
  
  module.hot.accept("./description-form.vue?vue&type=template&id=fbf36fa4", () => {
    api.rerender('fbf36fa4', render)
  })

}


export default __exports__